import React, {useState} from "react";
import '../../../css/diagonal.scss'
import addToMailchimp from 'gatsby-plugin-mailchimp'
import {useIntl} from "react-intl";
import SuccessAlert from "../../successAlert";
import ErrorAlert from "../../errorAlert";

const svg = (<svg
    viewBox="0 0 1428 174"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
>
    <defs>
        <linearGradient
            id="twGradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="0%"
        >
            <stop
                offset="0%"
                stopColor="#F59E0B"
            />
            <stop
                offset="100%"
                stopColor="#FCD34D"
            />
        </linearGradient>
    </defs>
    <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
    >
        <g
            transform="translate(-2.000000, 44.000000)"
            fill="#FFFFFF"
            fillRule="nonzero"
        >
            <path
                d="M0,0 C90.7283404,0.927527913 147.912752,27.187927 291.910178,59.9119003 C387.908462,81.7278826 543.605069,89.334785 759,82.7326078 C469.336065,156.254352 216.336065,153.6679 0,74.9732496"
                opacity="0.100000001"
            ></path>
            <path
                d="M100,104.708498 C277.413333,72.2345949 426.147877,52.5246657 546.203633,45.5787101 C666.259389,38.6327546 810.524845,41.7979068 979,55.0741668 C931.069965,56.122511 810.303266,74.8455141 616.699903,111.243176 C423.096539,147.640838 250.863238,145.462612 100,104.708498 Z"
                opacity="0.100000001"
            ></path>
            <path
                d="M1046,51.6521276 C1130.83045,29.328812 1279.08318,17.607883 1439,40.1656806 L1439,120 C1271.17211,77.9435312 1140.17211,55.1609071 1046,51.6521276 Z"
                id="Path-4"
                opacity="0.200000003"
            ></path>
        </g>
        <g
            transform="translate(-4.000000, 76.000000)"
            fill="url(#twGradient)"
            fillRule="nonzero"
        >
            <path d="M0.457,34.035 C57.086,53.198 98.208,65.809 123.822,71.865 C181.454,85.495 234.295,90.29 272.033,93.459 C311.355,96.759 396.635,95.801 461.025,91.663 C486.76,90.01 518.727,86.372 556.926,80.752 C595.747,74.596 622.372,70.008 636.799,66.991 C663.913,61.324 712.501,49.503 727.605,46.128 C780.47,34.317 818.839,22.532 856.324,15.904 C922.689,4.169 955.676,2.522 1011.185,0.432 C1060.705,1.477 1097.39,3.129 1121.236,5.387 C1161.703,9.219 1208.621,17.821 1235.4,22.304 C1285.855,30.748 1354.351,47.432 1440.886,72.354 L1441.191,104.352 L1.121,104.031 L0.457,34.035 Z"></path>
        </g>
    </g>
</svg>);


function Newsletter() {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const intl = useIntl();

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const response = await addToMailchimp(email);
            if (response.result === 'error') {
                if (response.msg && response.msg.match(/is already subscribed/g)) {
                    setSuccess(intl.formatMessage({id: 'newsletter_success'}))
                } else {
                    setError(intl.formatMessage({id: 'general_error'}))
                }
            } else {
                setSuccess(intl.formatMessage({id: 'newsletter_success'}))
            }
        } catch (error) {
            setError(intl.formatMessage({id: 'general_error'}))
        }
    };
    return (
        <div className="bg-one diagonal-box">
            <div className="content">
                <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
                    <h2 className="inline text-3xl font-extrabold tracking-tight text-gray-900 sm:block sm:text-4xl">
                        {intl.formatMessage({id: 'want_info'})}
                    </h2>
                    <span className="px-1"/>
                    <p className="inline text-3xl font-extrabold tracking-tight text-white sm:block sm:text-4xl">
                        {intl.formatMessage({id: 'sign_up_for_newsletter'})}
                    </p>
                    {success && (<SuccessAlert message={success}/>)}
                    {error && (<ErrorAlert message={error}/>)}
                    <form
                        className="mt-8 sm:flex"
                        onSubmit={handleSubmit}
                    >
                        <label
                            htmlFor="emailAddress"
                            className="sr-only"
                        >
                            {intl.formatMessage({id: 'email_address'})}
                        </label>
                        <input
                            id="emailAddress"
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                            type="email"
                            required
                            className="w-full px-5 py-3 placeholder-gray-500 focus:ring-gray-900 focus:border-gray-900 sm:max-w-xs border-gray-300 rounded-md"
                            placeholder={intl.formatMessage({id: 'enter_email_address'})}
                        />
                        <div className="mt-3 rounded-md shadow sm:mt-0 sm:ml-3 sm:flex-shrink-0">
                            <button
                                disabled={success || error}
                                type="submit"
                                className={`w-full flex items-center justify-center px-5 py-3 border border-transparent
                 text-base font-medium rounded-md text-white bg-gray-900 hover:text-secondary 
                 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white disabled:cursor-not-allowed
                 
                `}
                            >
                                {intl.formatMessage({id: 'notify_me'})}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Newsletter;
